/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tags_SummonsInputs */

const en_control_tags_summons = /** @type {(inputs: Control_Tags_SummonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summons`)
};

const zh_control_tags_summons = /** @type {(inputs: Control_Tags_SummonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`召唤`)
};

/**
* | output |
* | --- |
* | "Summons" |
*
* @param {Control_Tags_SummonsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tags_summons = /** @type {((inputs?: Control_Tags_SummonsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tags_SummonsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tags_summons(inputs)
	return zh_control_tags_summons(inputs)
});
export { control_tags_summons as "control.tags.summons" }